module.exports = __webpack_public_path__ + "static/media/hybriq.211c59aa.svg";